/* eslint-disable ember/no-computed-properties-in-native-classes, warp-drive/no-legacy-request-patterns */
import { tracked } from '@glimmer/tracking';
import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import moment from 'moment';
import { byKeys } from '@linc-technologies/linced-common/utils/arrays';

export default class LeaversListController extends Controller {
  @action
  setLeftAfter(value) {
    this.leftAfter = value;
  }

  @action
  setLeftBefore(value) {
    this.leftBefore = value;
  }

  queryParams = ['dental', 'withDest', 'leftAfter', 'leftBefore'];

  @service
  store;

  @tracked dental = false;
  @tracked withDest = false;
  @tracked leftAfter = moment().format('YYYY-MM-DD');
  @tracked leftBefore = moment().format('YYYY-MM-DD');
  @tracked sortProp = 'person.firstName';
  @tracked sortDir = 'asc';

  get title() {
    return this.dental
      ? `Dental List for Leavers`
      : `Leavers List ${this.withDest ? 'with Destination' : ''}`;
  }

  @computed('model.people.[]', 'sortProp', 'sortDir', 'leftAfter', 'leftBefore')
  get leavers() {
    // Merge person and enrolment records into one array so that we can access both readily.
    let leavers = this.model.people.map((person) => {
      let enrolment = null;
      if (!isEmpty(person.get('learner.enrolmentId'))) {
        enrolment = this.store.peekRecord(
          'people/enrolment',
          person.get('learner.enrolmentId'),
        );
      }
      return {
        person,
        enrolment,
      };
    });

    // Filter leavers based on given dates and enrolment records.
    let before = moment(this.leftBefore, 'YYYY-MM-DD');
    let after = moment(this.leftAfter, 'YYYY-MM-DD');
    leavers = leavers.filter((leaver) => {
      if (isEmpty(leaver.enrolment) || isEmpty(leaver.enrolment.exitDate)) {
        return false;
      }
      let exitDate = moment(leaver.enrolment.exitDate, 'YYYY-MM-DD');
      return (
        exitDate.isValid() &&
        exitDate.isSameOrBefore(before) &&
        exitDate.isSameOrAfter(after)
      );
    });

    // Sort filtered results.
    if (this.sortDir === 'desc') {
      return leavers.sort(byKeys(this.sortProp)).reverse();
    } else {
      return leavers.sort(byKeys(this.sortProp));
    }
  }

  @action
  onChangeSort({ sortProp, sortDir }) {
    this.sortProp = sortProp;
    this.sortDir = sortDir;
  }
}
